import {
  Box,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import AppButton from "../../components/app-button/AppButton";
import {
  CURRENCIES,
  CURRENCY_LABELS,
  DATE_TIME_FORMATS,
  DATE_TIME_FORMAT_LABELS,
  LANGUAGES,
  LANGUAGE_LABELS,
  ORDER_TYPES,
  ORDER_TYPE_LABELS,
  PAYMENT_METHODS,
  TIMEZONES,
  TIMEZONE_LABELS,
  getPaymentMethod,
} from "../../constants/enums";

function GeneralSettings(props) {
  const [orderType, setOrderType] = useState(ORDER_TYPES.DINE_IN);
  const [currency, setCurrency] = useState(CURRENCIES.INR);
  const [timeFormat, setTimeFormat] = useState(DATE_TIME_FORMATS.TWELVE_HOUR);
  const [language, setLanguage] = useState(LANGUAGES.ENGLISH);
  const [timezone, setTimezone] = useState(TIMEZONES.IST);
  const [roundOff, setRoundOff] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(PAYMENT_METHODS.CASH);
  const [showItemImages, setShowItemImages] = useState(true);

  const defaultSettings = {
    orderType: ORDER_TYPES.DINE_IN,
    currency: CURRENCIES.INR,
    timeFormat: DATE_TIME_FORMATS.TWELVE_HOUR,
    language: LANGUAGES.ENGLISH,
    timezone: TIMEZONES.IST,
    roundOff: false,
    paymentMethod: PAYMENT_METHODS.CASH,
    showItemImages: true,
  };

  const handleSave = () => {
    const settings = {
      orderType,
      currency,
      timeFormat,
      language,
      timezone,
      roundOff,
      paymentMethod,
      showItemImages,
    };
    console.log("✅ Saved Settings:", settings);
  };

  const handleReset = () => {
    setOrderType(defaultSettings.orderType);
    setCurrency(defaultSettings.currency);
    setTimeFormat(defaultSettings.timeFormat);
    setLanguage(defaultSettings.language);
    setTimezone(defaultSettings.timezone);
    setRoundOff(defaultSettings.roundOff);
    setPaymentMethod(defaultSettings.paymentMethod);
    setShowItemImages(defaultSettings.showItemImages);
  };

  return (
    <>
      <Box>
        <Card sx={{ mb: 3, p: 2, borderRadius: 3 }}>
          <CardContent>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                mb: 3,
              }}
            >
              App Preferences
            </Typography>

            <Box display="grid" gap={3}>
              {/* Default Order Type */}
              <FormControl fullWidth>
                <InputLabel>Default Order Type</InputLabel>
                <Select
                  value={orderType}
                  label="Default Order Type"
                  onChange={(e) => setOrderType(e.target.value)}
                >
                  {Object.values(ORDER_TYPES).map((type) => (
                    <MenuItem key={type} value={type}>
                      {ORDER_TYPE_LABELS[type]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Currency */}
              <FormControl fullWidth>
                <InputLabel>Currency</InputLabel>
                <Select
                  value={currency}
                  label="Currency"
                  disabled={true}
                  onChange={(e) => setCurrency(e.target.value)}
                >
                  {Object.values(CURRENCIES).map((type) => (
                    <MenuItem key={type} value={type}>
                      {CURRENCY_LABELS[type]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Date & Time Format */}
              <FormControl fullWidth>
                <InputLabel>Date & Time Format</InputLabel>
                <Select
                  value={timeFormat}
                  label="Date & Time Format"
                  disabled={true}
                  onChange={(e) => setTimeFormat(e.target.value)}
                >
                  {Object.values(DATE_TIME_FORMATS).map((type) => (
                    <MenuItem key={type} value={type}>
                      {DATE_TIME_FORMAT_LABELS[type]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Language */}
              <FormControl fullWidth>
                <InputLabel>Language</InputLabel>
                <Select
                  value={language}
                  label="Language"
                  disabled={true}
                  onChange={(e) => setLanguage(e.target.value)}
                >
                  {Object.values(LANGUAGES).map((type) => (
                    <MenuItem key={type} value={type}>
                      {LANGUAGE_LABELS[type]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Timezone */}
              <FormControl fullWidth>
                <InputLabel>Timezone</InputLabel>
                <Select
                  value={timezone}
                  label="Timezone"
                  disabled={true}
                  onChange={(e) => setTimezone(e.target.value)}
                >
                  {Object.values(TIMEZONES).map((type) => (
                    <MenuItem key={type} value={type}>
                      {TIMEZONE_LABELS[type]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Round-off Total */}
              <Box>
                <FormControlLabel
                  control={
                    <Switch
                      checked={roundOff}
                      onChange={(e) => setRoundOff(e.target.checked)}
                    />
                  }
                  label="Round-off Total"
                />
                <FormHelperText>
                  Automatically round the bill total to the nearest whole
                  number.
                </FormHelperText>
              </Box>

              {/* Default Payment Method */}
              <FormControl fullWidth>
                <InputLabel>Default Payment Method</InputLabel>
                <Select
                  label="Default Payment Method"
                  value={paymentMethod}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                >
                  {Object.values(PAYMENT_METHODS).map((method) => {
                    return (
                      <MenuItem key={method.value} value={method}>
                        {method.label}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              {/* Show item images toggle */}
              <Box>
                <FormControlLabel
                  control={
                    <Switch
                      checked={showItemImages}
                      onChange={(e) => setShowItemImages(e.target.checked)}
                    />
                  }
                  label="Show item images in Menu grid"
                />
                <FormHelperText>
                  Display item images on the Menu screen.
                </FormHelperText>
              </Box>
            </Box>

            {/* Save / Reset Buttons */}
            <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
              <AppButton onClick={handleReset}>Reset</AppButton>
              <AppButton variant="contained" onClick={handleSave}>
                Save
              </AppButton>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}

export default GeneralSettings;
